<mat-icon (click)="previous()" class="arrow">keyboard_arrow_left</mat-icon>
@for (item of items; track item; let i = $index) {
  <div
    class="bullet"
    [class.active]="activeIndex === i"
    (click)="updateIndex(i)"
  ></div>
}
<mat-icon (click)="next()" class="arrow">keyboard_arrow_right</mat-icon>
